module.exports = __webpack_public_path__ + "static/media/tsp.f902fee9.jpg";